/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import Agree from '../views/agree.vue';

export const route = [
  {
    path: '/agree',
    component: Agree,
    meta: {
      title: '用户协议/隐私政策'
    }
  }
];
